import React from "react";

export function SkeletonElement({ type }) {
  return <div className={`skeleton ${type}`}></div>;
}
